import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import ProjectPreviewGrid from './components/ProjectPreviewGrid';
import Icon from '../../components/AppIcon';
import SkillBadges from './components/SkillBadges';



const MissionControlHub = () => {
  return (
    <div className="min-h-screen bg-background">
      
      <Header />
      <main>
        <HeroSection />
        <ProjectPreviewGrid />
        
        <SkillBadges />
      
      </main>
      {/* Footer */}
      <footer className="bg-deep-space text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Brand Section */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-rocket-fire to-electric-cyan rounded-lg flex items-center justify-center shadow-brand">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" fill="white"/>
                  </svg>
                </div>
                <div>
                  <h3 className="font-headline text-xl text-sky-500">PortFolio</h3>
                  <p className="text-sm text-slate-400">Ready To Develop</p>
                </div>
              </div>
              <p className="text-slate-300 mb-4 max-w-md">
                Transforming ideas into digital reality through innovative web development, 
                modern frameworks, and user-centered design.
              </p>
              <div className="flex space-x-4">
                {[
  { name: 'Github', url: 'https://github.com/LokendraKumar8' },
  { name: 'Linkedin', url: 'https://www.linkedin.com/in/lokendra-kumar-563a41251/' },
  { name: 'Twitter', url: 'https://x.com/Lokendra9214' },
  { name: 'Mail', url: 'mailto:lokendrakumar582809@gmail.com' }
]?.map((social, index) => (
                                  <a href={`${social.url}`}><button
                                    key={index}
                                    className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-brand"
                                  >
                                    <Icon name={social.name} size={18} className="text-white" />
                                  </button></a>
                                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-value-prop text-white mb-4">Navigation</h4>
              <ul className="space-y-2">
                {[
                  { name: 'Mission Control', path: '/mission-control-hub-homepage' },
                  { name: 'About Mission', path: '/about-mission' },
                  { name: 'Project Hangar', path: "#ProjectHanger" },
                  { name: 'Skills And Technologies', path: '#SkillsAndTech' },
                  { name: 'Collaboration Station', path: '/collaboration-station' }
                ]?.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link?.path}
                      className="text-slate-400 hover:text-rocket-fire transition-brand text-sm"
                    >
                      {link?.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-value-prop text-white mb-4">Get in Touch</h4>
              <div className="space-y-2 text-sm">
                <p className="text-slate-400">lokendrakumar582809@gmail.com</p>
                <p className="text-slate-400">+91-7983269306</p>
                
              </div>
            </div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">            
            <div className="border-t border-slate-700 pt-6">
              <p className="text-slate-500 text-sm">
                 Crafted with passion and precision by Lokendra Kumar.
              </p>
            </div>
          </div>
        </div>
        </div>
      </footer>
      
    </div>
  );
};

export default MissionControlHub;